<script setup>

</script>

<template>
  <button class="btn">
    <slot></slot>
  </button>
</template>

<style scoped lang="scss">
  @import "/src/style/variable";
  .btn {
    display: flex;
    border: 1px solid black;
    padding: 15px;
    justify-content: center;
    align-items: center;
    border-radius: 250px;
    font-size: 16px;
    font-family: $font-family;
    font-weight: 500;
    min-width: 245px;
    cursor: pointer;
    background-color: transparent;
    &.orange {
      border: 2px solid $color-orange;
      background-color: $color-orange;
      color: $color-white;
      &:hover {
        background-color: transparent;
        color: $color-orange;
      }
    }
    &.blue {
      border: 2px solid $color-navy-blue;
      color: $color-navy-blue;
      &:hover {
        background-color: $color-navy-blue;
        color: $color-white;
      }
    }
  }
</style>